// Third-party Libraries
import { toast } from "react-toastify";  // Toast notification library for React
import "./Notification.css"

/**
 * Creates a success toast notification
 * 
 * @param {string} msg - Custom success message to display
 *                      Defaults to "Success" if not provided
 * 
 * Configuration:
 * - Position: Bottom right corner
 * - Duration: 2 seconds (2000ms)
 * - Interactive: Can be clicked to close, paused on hover
 * - Draggable: Can be moved around screen
 * - Progress: Shows completion progress bar
 */
export const CreateSuccessNotification = (msg) => {
  toast.success(msg || `Success`, {
    className: 'toast-error-container toast-error-container-after',
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

/**
 * Creates an error toast notification
 * 
 * @param {string} msg - Custom error message to display
 *                      Defaults to generic error message if not provided
 * @param {number} timer - Custom duration in milliseconds
 *                        Defaults to 2000ms if not provided
 * 
 * Configuration:
 * - Position: Bottom right corner
 * - Duration: Custom or 2 seconds
 * - Interactive: Can be clicked to close, paused on hover
 * - Draggable: Can be moved around screen
 * - Theme: Colored background for better visibility
 * - Progress: Hidden progress bar
 */
export const CreateErrorNotification = (msg, timer) => {
  toast.error(msg || `Something went wrong! Please try again.`, {
    className: 'toast-error-container toast-error-container-after',
    position: "bottom-right",
    autoClose: timer ? timer : 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });
};